module.exports = __webpack_public_path__ + "assets/date.ebc68555.svg";